<div class="ud-dialog">
  <div class="ud-header">
    <div class="ud-title-wrap">
      <div class="ud-title-icon"><mat-icon>groups</mat-icon></div>
      <div>
        <h2 class="ud-title">{{ adding ? 'Add team' : 'Edit team' }}</h2>
        <div class="ud-subtitle">{{ adding ? 'Group users together to assign work faster' : 'Update this team’s name and members' }}</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="ud-close" [disabled]="saveClick" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>

  <form id="saveTeam" class="ud-body" (ngSubmit)="save()">
    <div class="ud-field">
      <label class="ud-label">Team name <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat">
        <input matInput placeholder="e.g. Cultivation Crew" name="name" required [(ngModel)]="team.name">
      </mat-form-field>
    </div>
    <div class="ud-field ud-picker">
      <label class="ud-label">Members</label>
      <app-user-select-multiple [displayUserList]="true" [removableSelectionList]="true" [(userIds)]="team.userIds"></app-user-select-multiple>
      <p class="ud-help">{{ memberCount }} user{{ memberCount === 1 ? '' : 's' }} on this team.  Teams can be assigned to tasks in place of individual users.</p>
    </div>
  </form>

  <div class="ud-footer">
    <button mat-button mat-dialog-close class="ud-btn-ghost" [disabled]="saveClick">Cancel</button>
    <button type="submit" form="saveTeam" class="ud-btn-primary" [disabled]="saveClick">
      @if (saveClick) { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> } @else { <span>{{ adding ? 'Create team' : 'Save changes' }}</span><mat-icon>check</mat-icon> }
    </button>
  </div>
</div>
